import { defineStore } from 'pinia';

/**
 * 本系统中，不存在多个需要缓存的页面相互切换的情况，所以为了保证页面正常缓存，即 cacheViews 仅存储一个页面name
 */
export const useTagViewStore = defineStore('tagView', {
  state: () => ({
    tagViews: [],
    cacheViews: '', // 需要缓存的页面name
  }),
  actions: {
    addCacheView (route) {
      const index = this.cacheViews.indexOf(route.name);
      if (index === -1) {
        this.tagViews.push(route);
        // this.cacheViews.push(route.name);
      }
      this.cacheViews = route.name;
    },
    delCacheView (route) {
      const index = this.cacheViews.indexOf(route.name);
      if (index !== -1) {
        this.tagViews.splice(index, 1);
        // this.cacheViews.splice(index, 1);
      }
      this.cacheViews = '';
    },
    clearCacheViews () {
      // this.cacheViews = [];
      this.tagViews = [];
      this.cacheViews = '';
    },
  },
});


// WEBPACK FOOTER //
// ./src/pinia/tagView.js